import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { CATEGORY_META, imgUrl, countByCategory } from "@/data/products";
import { CATEGORIES } from "@/constants/testIds";
import { ToyBrick, Lamp, Swords, Palette, Wrench, Gem, ArrowRight } from "lucide-react";

const ICONS = { ToyBrick, Lamp, Swords, Palette, Wrench, Gem };

export const Categories = ({ onSelect }) => {
  return (
    <section
      id="categories"
      data-testid={CATEGORIES.section}
      className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20"
    >
      <Reveal>
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-neo-cyan">
              Shop by category
            </span>
            <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight sm:text-4xl">
              Explore the full range of designs
            </h2>
          </div>
          <button
            onClick={() => onSelect?.("All")}
            className="inline-flex items-center gap-1.5 rounded-lg border border-border/70 bg-secondary/50 px-3 py-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            View all <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </Reveal>

      <StaggerGroup className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
        {CATEGORY_META.map((c) => {
          const Icon = ICONS[c.icon] || ToyBrick;
          return (
            <StaggerItem key={c.name}>
              <button
                data-testid={CATEGORIES.card}
                data-category={c.name}
                onClick={() => onSelect?.(c.name)}
                className="group flex h-full w-full flex-col overflow-hidden rounded-2xl border border-border/70 bg-card/70 text-left backdrop-blur-md transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:border-[rgba(0,229,255,0.4)] hover:shadow-[var(--shadow-elev-2)]"
              >
                <div
                  className="relative h-24 w-full"
                  style={{ background: "radial-gradient(circle at 50% 35%, #f6f8fc, #dfe5ee)" }}
                >
                  <img
                    src={imgUrl(c.sample)}
                    alt={c.name}
                    loading="lazy"
                    className="h-full w-full object-contain p-2 transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="flex flex-1 flex-col gap-1 p-3">
                  <div className="flex items-center gap-1.5">
                    <Icon className="h-4 w-4 text-neo-cyan" />
                    <span className="font-display text-sm font-semibold text-foreground">
                      {c.name}
                    </span>
                  </div>
                  <span className="font-mono text-[10px] text-muted-foreground">
                    {c.blurb}
                  </span>
                  <span className="mt-auto pt-1 font-mono text-[10px] text-neo-cyan">
                    {countByCategory(c.name)}+ designs
                  </span>
                </div>
              </button>
            </StaggerItem>
          );
        })}
      </StaggerGroup>
    </section>
  );
};
